import Vue from 'vue';
import VueRouter from 'vue-router';
import Index from '../views/Index.vue';
import NotFound from '../views/NotFound.vue';
import Internas from '../views/Internas.vue';
import Door from '../views/Door';
import Programming from '../views/Programming.vue';
import Locutores from '../views/Locutores.vue';
import Albums from '../views/Albums.vue';
import AlbumDetails from '../views/AlbumDetails.vue';
import Blog from '../views/Blog.vue';
import BlogShow from '../views/BlogShow.vue';
import Contact from '../views/Contact.vue';
import ProgramDetails from '../views/ProgramDetails.vue';
import LocutorDetails from '../views/LocutorDetails.vue';
import Events from '../views/Events.vue';
import Event from '../views/Event.vue';
import Message from '../views/Message.vue';
import Videos from '../views/Videos.vue';
import Promotions from '../views/Promotions.vue';
import PromotionDetails from '../views/PromotionDetails.vue';
import Meta from 'vue-meta';

Vue.use(VueRouter);
Vue.use(Meta);


let router = new VueRouter({
  mode: 'history',
  routes: [
    {name: 'index', path: '/', component: Index},
    {name: 'programacao', path: '/programacao', component: Programming},
    {name: 'programacao', path: '/programa/:id/:slug?', component: ProgramDetails},
    {name: 'locutores', path: '/locutores', component: Locutores},
    {name: 'locutores', path: '/locutor/:id/:slug?', component: LocutorDetails},
    {name: 'albuns', path: '/albuns', component: Albums},
    {name: 'album', path: '/album/:id?/:slug?', component: AlbumDetails},
    {name: 'noticias', path: '/noticias/:categoryId?/:slug?', component: Blog},
    {name: 'noticias', path: '/noticia/:id/:slug?', component: BlogShow},
    {name: 'contato', path: '/contato', component: Contact},
    {name: 'not-found', path: '/not-found', component: Index},
    {name: 'internas', path: '/internas/:page', component: Internas},
    {name: 'door', path: '/door/:page', component: Door},
    {name: 'eventos', path: '/eventos', component: Events},
    {name: 'eventos', path: '/evento/:id/:slug?', component: Event},
    {name: 'recados', path: '/recados', component: Message},
    {name: 'videos', path: '/videos', component: Videos},
    {name: 'promocoes', path: '/promocoes', component: Promotions},
    {name: 'promocao', path: '/promocao/:id/:slug?', component: PromotionDetails},
    {name: 'all', path: '*', component: Index}
  ]
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js